import { fetchLocationDataReducer } from './fetchLocationData.thunk';
import { fetchSelectedLocationReducer } from './fetchSelectedLocation.thunk';
import { selectLocationReducer } from './selectLocation.thunk';
import { deactivateAutopilotReducer } from './deactivateAutopilot.thunk';
import { activateAutopilotReducer } from './activateAutopilot.thunk';
import { deactivateAutoRequestReducer } from './deactivateAutoRequest.thunk';
import { activateAutoRequestReducer } from './activateAutoRequest.thunk';
import { fetchSquareMerchantReducer } from './fetchSquareMerchant.thunk';
import { fetchFacebookSelectedPageReducer } from './fetchFacebookSelectedPage.thunk';
import { updateDefendResponseReducer } from './updateDefendResponse.thunk';

export * from './fetchSquareMerchant.thunk';
export * from './fetchFacebookSelectedPage.thunk';
export * from './fetchLocationData.thunk';

export const locationThunkReducers = {
  ...fetchLocationDataReducer,
  ...fetchSquareMerchantReducer,
  ...fetchFacebookSelectedPageReducer,
  ...selectLocationReducer,
  ...fetchSelectedLocationReducer,
  ...activateAutopilotReducer,
  ...activateAutoRequestReducer,
  ...deactivateAutopilotReducer,
  ...deactivateAutoRequestReducer,
  ...updateDefendResponseReducer,
};
